import { getGameShareUrl } from './shareGameLink'
import { applyRefIdSearchParam } from './refIdShareParam'

function applyCardIdSearchParam(url: URL, encodedCardId: string): void {
    const token = encodedCardId.trim()
    if (token) {
        url.searchParams.set('cID', token)
    }
}

export function buildGameEndFriendsShareUrl(
    encodedCardId: string,
): string {
    const url = new URL(getGameShareUrl())
    applyCardIdSearchParam(url, encodedCardId)
    return url.toString()
}

export function buildGameEndParentShareUrl(
    refDocumentId: string | null | undefined,
    encodedCardId: string,
): string {
    const url = new URL(getGameShareUrl())
    applyCardIdSearchParam(url, encodedCardId)
    applyRefIdSearchParam(url, refDocumentId)
    return url.toString()
}
